import * as React from 'react';
import styled from '@emotion/styled';
import { FilterUploadHistory } from '../../../../../../interfaces/interfaces';
import adaptString from '../../../../../../utils/adapters/stringAdapter';

export interface InputFilterTableColumnsProps {
  label: string;
  cleanInputs: object;
  setFilterData(x: Partial<FilterUploadHistory>): void;
}

const StyledInput = styled.input`
  width: 90%;
`;

const InputFilterTableColumns = ({ label, setFilterData, cleanInputs }: InputFilterTableColumnsProps) => {
  const [inputFilterValue, setInputFilterValue] = React.useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setInputFilterValue(value);
    setFilterData({ [name]: adaptString(value) });
  };
  React.useEffect(() => {
    setInputFilterValue('');
    setFilterData({ [label]: '' });
  }, [cleanInputs, label, setFilterData]);
  return (
    <div>
      <StyledInput value={inputFilterValue} onChange={handleChange} name={label} />
    </div>
  );
};

export default InputFilterTableColumns;
